export default __webpack_public_path__ + "static/threescreen-95dd0e5644579bb217d4ebbec5ecd2c2.png";